import { render, staticRenderFns } from "./AppendixUQKHD.vue?vue&type=template&id=0bc40c6a&scoped=true"
import script from "./AppendixUQKHD.vue?vue&type=script&lang=js"
export * from "./AppendixUQKHD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc40c6a",
  null
  
)

export default component.exports